import { motion } from 'framer-motion';
import { Typography, ListItemButton } from '@mui/material';
import CheckY from '../../../../Assets/Images/CheckY.png';
import CheckN from '../../../../Assets/Images/CheckN.png';
import PerButton from './PerButton';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { PermitActions } from '../../../../Reducer/PermitReducer';

export default function TypeWork({ Search2 }) {
  const activeStep = useSelector((state) => state.common.activeStep);
  const baseInfo = useSelector((state) => state.permit.baseInfo);
  const codeList = useSelector((state) => state.permit.codeInfo);
  const dispatch = useDispatch();

  return (
    <div>
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: 0.3,
        }}
      >
        <p>먼저 작업 종류를 선택할게요.</p>
        <p style={{ fontSize: '16px', color: '#939393' }}>
          진행할 작업 종류를 한 가지 선택해주세요.
        </p>

        <div style={{ marginBottom: '16px' }}>
          {codeList?.workTypes && codeList.workTypes.length > 0 ? (
            codeList.workTypes.map((item, index) => (
              <ListItemButton
                key={index}
                sx={{
                  mt: 1.25,
                  p: 2,
                  py: 1.5,
                  gap: 1,
                  border: 1,
                  borderRadius: 2.5,
                  borderColor:
                    baseInfo.workType === item.workType ? '#80CB66' : '#E8E8E8',
                  backgroundColor:
                    baseInfo.workType === item.workType ? '#ECF6E8' : '#fff',
                  '&:focus': {
                    outline: 'none',
                    borderColor:
                      baseInfo.workType === item.workType
                        ? '#80CB66'
                        : '#E8E8E8',
                    backgroundColor:
                      baseInfo.workType === item.workType ? '#ECF6E8' : '#fff',
                  },
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                onClick={() => {
                  const isSame = baseInfo.workType === item.workType;

                  dispatch(
                    PermitActions.setBaseInfo({
                      workType: isSame ? '' : item.workType,
                      workItemId: isSame ? '' : item.workItemId,
                    })
                  );

                  if (!isSame && item.workItemId) {
                    Search2({ workItemId: item.workItemId });
                  }
                }}
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  {item.workTypeNm}
                </Typography>
                <img
                  src={baseInfo.workType === item.workType ? CheckY : CheckN}
                  alt="체크"
                />
              </ListItemButton>
            ))
          ) : (
            <div
              style={{ textAlign: 'center', padding: '20px', color: '#939393' }}
            >
              작업 종류를 불러오는 중...
            </div>
          )}
        </div>

        {/* 버튼 */}
        <PerButton
          cancelText={'이전'}
          onCancel={() => {
            dispatch(CommonActions.setActiveStep(activeStep - 1));
          }}
          onClick={() => {
            if (!baseInfo.workType || baseInfo.workType === '') {
              dispatch(
                showSnackbar({
                  message: '작업 종류를 선택해주세요.',
                  type: 'warning',
                })
              );
              return;
            }

            dispatch(CommonActions.increaseStep());
            dispatch(BottomSheetActions.CloseBottomSheet());
          }}
        />
      </motion.div>
    </div>
  );
}
